@if (dealCompanies$ | async; as dealCompanies) {
  <mat-tab-group selectedIndex="1">
    <mat-tab label="Low" data-test="tab-low">
      @if (dealCompanies.dealCompanyRecords.length > 0) {
        <div class="chart-container">
          <canvas id="LowScenarioDealBubbleChart"></canvas>
        </div>
      } @else {
        <div class="detail-card-content" style="color: grey">
          No data available for the low scenario.
        </div>
      }
    </mat-tab>
    <mat-tab label="Base" data-test="tab-base">
      @if (dealCompanies.dealCompanyRecords.length > 0) {
        <div class="chart-container">
          <canvas id="BaseScenarioDealBubbleChart"></canvas>
        </div>
      } @else {
        <div class="detail-card-content" style="color: grey">
          No data available for the base scenario.
        </div>
      }
    </mat-tab>
    <mat-tab label="High" data-test="tab-high">
      @if (dealCompanies.dealCompanyRecords.length > 0) {
        <div class="chart-container">
          <canvas id="HighScenarioDealBubbleChart"></canvas>
        </div>
      } @else {
        <div class="detail-card-content" style="color: grey">
          No data available for the high scenario.
        </div>
      }
    </mat-tab>
  </mat-tab-group>
  <div style="text-align: end"> (!) Cashflow amounts over 1'000m are shown at the same bubble size as 1'000m.</div>
}
